import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";

// 1–3 suggested album names from the photos' metadata / search words, as tappable chips
export const NameChips = ({ itemIds, albumIds, q, space, onPick, testid = "name-chips" }) => {
  const [names, setNames] = useState([]);
  const key = JSON.stringify([itemIds, albumIds, q, space]);
  useEffect(() => {
    if (!itemIds?.length && !albumIds?.length && !q) return setNames([]);
    api.post("/albums/suggest-names", { item_ids: itemIds || [], album_ids: albumIds || [], q: q || null, space: space || "all" })
      .then((r) => setNames(r.data.names)).catch(() => setNames([]));
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!names.length) return null;
  return (
    <div className="flex flex-wrap gap-2 items-center" data-testid={testid}>
      <Sparkles size={13} className="text-neutral-500" />
      {names.map((n, i) => (
        <button type="button" key={n} className="name-chip" onClick={() => onPick(n)} data-testid={`${testid}-${i}`}>{n}</button>
      ))}
    </div>
  );
};
